import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { FormBody } from '../../../Form'
import { FormikField } from '../../../Formik'
import { Content } from '../../../Modal'
import { RadioGroup } from '../../RadioGroup'

import * as styles from './FormFields.module.css'

function FormFields({
  actionsProps,
  cancelProps,
  getOptions,
  name,
  radioComponentProps,
  submitProps,
  title,
  onCancel,
}) {
  const { t } = useTranslation()

  const options = getOptions(t)

  return (
    <FormBody
      actionsProps={{
        ...actionsProps,
        ButtonAdd: null,
        ButtonClear: null,
        UploadComponent: null,
        cancelProps: {
          ...cancelProps,
          height: cancelProps?.height || 40,
          onClick: onCancel,
        },
        className: styles.actions,
        submitProps: {
          ...submitProps,
          height: submitProps?.height || 40,
          title: submitProps?.title || 'Modal.SaveBtnKey',
        },
      }}
    >
      <Content>
        <FormikField
          Component={RadioGroup}
          Field={Fragment}
          name={name}
          options={options}
          radioComponentProps={radioComponentProps}
          title={title}
        />
      </Content>
    </FormBody>
  )
}

export default FormFields
